/* GET ADS */
export const GET_ADS = "GET_ADS"
export const GET_ADS_SUCCESS = "GET_ADS_SUCCESS"
export const GET_ADS_ERROR = "GET_ADS_ERROR"

/* GET AD BY ID */
export const GET_AD_BY_ID = "GET_AD_BY_ID"
export const GET_AD_BY_ID_SUCCESS = "GET_AD_BY_ID_SUCCESS"
export const GET_AD_BY_ID_ERROR = "GET_AD_BY_ID_ERROR"

/*CREATE AD */
export const CREATE_NEW_AD = "CREATE_NEW_AD"
export const NEW_AD_SUCCESS = "NEW_AD_SUCCESS"
export const NEW_AD_ERROR = "NEW_AD_ERROR"

/*DUPLICATE AD */
export const DUPLICATE_AD = "DUPLICATE_AD"
export const DUPLICATE_AD_SUCCESS = "DUPLICATE_AD_SUCCESS"
export const DUPLICATE_AD_ERROR = "DUPLICATE_AD_ERROR"
// using new AD success and failure for duplicate

/*MODIFY AD */
export const MODIFY_AD = "MODIFY_AD"
export const MODIFY_AD_SUCCESS = "MODIFY_AD_SUCCESS"
export const MODIFY_AD_ERROR = "MODIFY_AD_ERROR"

/*DELETE AD */
export const DELETE_AD = "DELETE_AD"
export const DELETE_AD_SUCCESS = "DELETE_AD_SUCCESS"
export const DELETE_AD_ERROR = "DELETE_AD_ERROR"

export const GET_ADS_STATS = "GET_ADS_STATS"
export const GET_ADS_STATS_SUCCESS = "GET_ADS_STATS_SUCCESS"
export const GET_ADS_STATS_ERROR = "GET_ADS_STATS_ERROR"

/* GET QF CREATIVES STATS */
export const GET_QF_CREATIVES_STATS = "GET_QF_CREATIVES_STATS"
export const GET_QF_CREATIVES_STATS_SUCCESS = "GET_QF_CREATIVES_STATS_SUCCESS"
export const GET_QF_CREATIVES_STATS_ERROR = "GET_QF_CREATIVES_STATS_ERROR"
